import { AfterViewInit, Directive, inject, input, OnDestroy } from '@angular/core';
import { MatOption, MatSelect } from '@angular/material/select';

import { startWith, Subscription } from 'rxjs';

import { stringListsEqualInAnyOrder } from '../utils/list.util';

// Derived from: https://angular-material.dev/articles/mat-select-all
@Directive({
	selector: 'mat-option[dixSelectAll]',
})
export class SelectAllDirective implements AfterViewInit, OnDestroy {
	allValues = input.required<string[]>();
	value = input.required<string>();

	private matSelect = inject(MatSelect);
	private matOption = inject(MatOption);

	private subscription = new Subscription();

	ngAfterViewInit(): void {
		const parentSelect = this.matSelect;
		const parentFormControl = parentSelect.ngControl.control;

		this.subscription.add(
			this.matOption.onSelectionChange.subscribe((ev) => {
				if (ev.isUserInput) {
					if (ev.source.selected) {
						parentFormControl?.setValue(this.allValues());
						this.matOption.select(false);
					} else {
						parentFormControl?.setValue([]);
						this.matOption.deselect(false);
					}
				}
			}),
		);

		this.subscription.add(
			this.matSelect.valueChange.pipe(startWith(this.matSelect.value)).subscribe((value: string[]) => {
				this.syncToValue(value);
			}),
		);
	}

	syncToValue(value: string[]) {
		if (value.includes(this.value())) return;
		if (!stringListsEqualInAnyOrder(value, this.allValues())) {
			this.matOption.deselect(false);
		} else {
			this.matOption.select(false);
		}
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}
}
